// FIX: Prevent auto-scroll from Webflow tabs on page load
// PROBLEM: Webflow TabsWrapper calls nextTabHeader?.focus() during initialization,
// which triggers browser's scroll-into-view behavior, causing unwanted page scroll
// SOLUTION: Temporarily override focus() to use preventScroll:true for w-tab-link elements
// during the critical 100ms initialization window, then restore normal behavior
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export const preventWebflowTabsAutoScroll = ()=>{
    const originalFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function(options = {}) {
        if (this.classList.contains("w-tab-link")) {
            return originalFocus.call(this, _object_spread_props(_object_spread({}, options), {
                preventScroll: true
            }));
        }
        return originalFocus.call(this, options);
    };
    setTimeout(()=>{
        HTMLElement.prototype.focus = originalFocus;
    }, 100);
};
